import { CSSProperties } from 'react'

import { $patchStyleText } from '@lexical/selection'
import { $getSelection, createCommand, LexicalEditor } from 'lexical'
import { camelCase, isNil, kebabCase } from 'lodash'

/**
 * style 字符串转成 CSSProperties 对象
 */
export const styleText2Css = (styleText?: string | null) => {
  if (!styleText) {
    return {}
  }
  const cssProperties: CSSProperties = {}
  const styleArr = styleText.split(';')
  styleArr.forEach(style => {
    const [key, value] = style.split(':')
    if (key && value) {
      cssProperties[camelCase(key)] = value.trim()
    }
  })
  return cssProperties
}

/**
 * 转成 lexical patchStyleText 需要的格式
 */
const css2PatchStyle = (cssProperties: CSSProperties) => {
  return Object.entries(cssProperties).reduce((acc, [key, value]) => {
    const styleKey = kebabCase(key)
    acc[styleKey] = value
    return acc
  }, {})
}

/**
 * 转成 style 属性的字符串值
 */
export const css2StyleText = (cssProperties: CSSProperties) => {
  const styleObj = css2PatchStyle(cssProperties)
  return Object.entries(styleObj).reduce((acc, [key, value]) => {
    return isNil(value) || value === '' ? acc : `${acc}${key}:${value};`
  }, '')
}

/**
 * 设置元素的样式
 */
export const setDomStyle = (dom: HTMLElement, css?: CSSProperties) => {
  if (css) {
    const styleText = css2StyleText(css)
    dom.setAttribute('style', styleText)
  }
}

export const PATCH_STYLE_TEXT_COMMAND = createCommand<CSSProperties>(
  'PATCH_STYLE_TEXT_COMMAND'
)

/**
 * 设置选区的样式必须全局使用该方法
 */
export const $setSelectionStyle = (
  editor: LexicalEditor,
  cssProperties: CSSProperties,
  cb?: () => void
) => {
  editor.update(() => {
    const selection = $getSelection()
    if (selection) {
      $patchStyleText(selection, css2PatchStyle(cssProperties))
      editor.dispatchCommand(PATCH_STYLE_TEXT_COMMAND, cssProperties)
    }
    cb?.()
  })
}
